import Constants from "../../../../Constants";
import ApiKeySection from "./ApiKeySection";
import InternalApiKeyModal from "./InternalApiKeyModal";

const InternalApiKeySec = () => {
  return (
    <ApiKeySection
      title="Generate Api Access Key"
      buttonText="Generate Api Access Key"
      modal={InternalApiKeyModal}
      getApiUrl={Constants.ApiUrl.user.getUserApiKeys}
      deleteApiUrl={Constants.ApiUrl.user.revokedApiKey}
    />
    
  );
};

export default InternalApiKeySec;
